"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tableContext = require("../../Context/tableContext");
var SortButton = function SortButton(_ref) {
  var column = _ref.column;
  var isCanSort = !!column.sorter;
  if (!isCanSort) {
    return null;
  }
  var sortDirections = column.sortDirections || _tableContext.eventHub.getState('sortDirections');
  var isSortAscending = sortDirections.some(function (item) {
    return item.indexOf('asc');
  });
  var isSortDescending = sortDirections.some(function (item) {
    return item.indexOf('desc');
  });
  var isAscend = selectedSort && selectedSort === 'asc';
  var isDescend = selectedSort && selectedSort === 'desc';
};
SortButton.defaultProps = {
  sortDirections: []
};
var _default = exports.default = SortButton;